import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Helmet } from "react-helmet"
import DateFnsUtils from "@date-io/date-fns"
import { Router, Route } from "react-router-dom"
import { createBrowserHistory } from "history"
import { ToastContainer } from "react-toastify"
import _ from "lodash"
import "react-toastify/dist/ReactToastify.css"
import * as ServiceAPI from "@services"
import * as constantsAPI from "@constants"
import { ThemeProvider } from "styled-components/macro"
import { create } from "jss"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
  jssPreset,
} from "@material-ui/core/styles"
import createTheme from "./theme"
import Routes from "./routes/Routes"
import { QueryParamProvider } from "use-query-params"
import {
  userKeycloakAttributes,
  userProfileDetails,
} from "./reduxSagas/admin/actions"
import jwt_decode from "jwt-decode"
import UserService from "./services/UserService"
import Spinner from "./components/Spinner"
import { DashboardContext } from "@utils"
import ForgetPassword from "./pages/auth/ForgetPassword"
import Receipt from "./pages/Receipt/Receipt"
import Page404 from "./pages/auth/Page404"
import UnAuthorizedUser from "./pages/auth/UnAuthorizedUser"
import AppLogout from "./layouts/AppLogout"
import renderCustomRedirect from "./CustomRedirect"
import { AppContext } from "@utils"
import userApi from "./services/user/api"
import * as Utils from "@utils"
import { useTranslation } from "react-i18next"
import { useGlobalStates } from "@state"
import "./styles.css"

import styled from "styled-components"
import { tenantSample } from "./fixture"
import {
  snapshotLoginOnboardingFlags,
  syncSaasSelectedTenantOnboardingFlags,
} from "./utils/tenantOnboardingFlags"
export const PageMainWrapper = styled("div")``
const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}
const getLightness = (r, g, b) => 0.2126 * r + 0.7152 * g + 0.0722 * b
const isDark = (r, g, b) => getLightness(r, g, b) < 150
const isLight = (r, g, b) => getLightness(r, g, b) > 150
const hexTorgb = (hex) => [
  ("0x" + hex?.[1] + hex?.[2]) | 0,
  ("0x" + hex?.[3] + hex?.[4]) | 0,
  ("0x" + hex?.[5] + hex?.[6]) | 0,
]
const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
})
export const history = createBrowserHistory()
window["historyW"] = history
const renderDynamicStylesColor = (props) => {
  const { getAppThemes = {} } = props || {}
  return (
    <style>
      {`

        .k-grid-norecords td, .cls-tb-empty-kit {
          height: 50vh !important;
        }
        div[role="presentation"].MuiDialog-root {
          z-index: 1300 !important;
        }
        .k-animation-container.k-animation-container-relative {
          z-index: 1350 !important;
        }
        :root {
          --primaryColor: ${getAppThemes?.primaryColor};
          --secondaryColor: ${getAppThemes?.secondaryColor};
          --optionBgColor: ${getAppThemes?.optionBgColor};
          --primaryTextColor: ${getAppThemes?.primaryTextColor};
          --secondaryTextColor: ${getAppThemes?.secondaryTextColor};
          --darkColor: ${getAppThemes?.darkColor};
          --lightColor: ${getAppThemes?.lightColor};
          --black: ${getAppThemes?.black};
          --white: ${getAppThemes?.white};
          --gray: ${getAppThemes?.gray};
        }
      `}
    </style>
  )
}
function App() {
  const theme = useSelector((state) => state.themeReducer)
  const { t = () => "", i18n = {} } = useTranslation()
  let defaultGetAppThemes = {
    companyLargeLogImageUrl: "",
    companySmallLogImageUrl: "",
    primaryColor: "#df86bb",
    secondaryColor: "#280b2b",
    darkColor: "#140316",
    lightColor: "#fff3fb",
    primaryTextColor: "#ffffff",
    secondaryTextColor: "#ffffff",
    textColor: "#000000",
    black: "#000000",
    white: "#FFFFFF",
    gray: "#d0d0d0",
  }
  let objUserProfileDetails = {}
  const dispatch = useDispatch()
  const getGlobalAppStates = useGlobalStates() || {}
  const [getHITLAccessibility, setHITLAccessibility] = React.useState(false)
  const [isLoader, setLoader] = React.useState(false)
  const [showMore, setShowMore] = React.useState(false)
  const [getStorageData, setStorageData] = React.useState({
    storageId: "",
    storageList: [],
  })
  const [getStoreSelectedType, setStoreSelectedType] = React.useState([])
  const [getStoreType, setStoreType] = React.useState([])
  const [getStoreTenantBasedType, setStoreTenantBasedType] = React.useState([])
  const [getRoleGlobalAttributes, setRoleGlobalAttributes] = React.useState({})
  const [getAppThemes, setAppThemes] = React.useState(defaultGetAppThemes)
  const flag = useSelector((state) => state.loginstateReducer)
  const [roleName, setRoleName] = React.useState("")
  const [isActive, setIsActive] = React.useState(true)
  const [routesWithActiveStatus, setRoutesWithActiveStatus] = React.useState([])
  const [countryList, setCountryList] = React.useState([])
  const [getGlobalCountryList, setGlobalCountryList] = React.useState([])

  /**
   * @Common_API_Start
   */
  const bindUserLogoDetails = async (objTheme, objRealm) => {
    let black = "#000000"
    let white = "#ffffff"
    let gray = "#F9F9FC"

    if (window !== undefined) {
      localStorage.setItem("theme", JSON.stringify(objTheme))
      const {
        primaryColor = "",
        secondaryColor = "",
        darkColor = "",
        lightColor = "",
      } = objTheme || {}
      const { largeLightLogo = "", largeDarkLogo = " ", smallLogo = "" } =
        objRealm || {}

      const rgb1 = hexTorgb(primaryColor)
      const rgb2 = hexTorgb(secondaryColor)

      let primaryTextColor = isDark(...rgb1) ? "#ffffff" : "#000000"
      let secondaryTextColor = isDark(...rgb2) ? "#ffffff" : "#000000"

      localStorage.setItem(
        "realmPaymentConfigEnable",
        objRealm?.paymentConfigEnable || false
      )

      setAppThemes({
        ...getAppThemes,
        primaryTextColor,
        secondaryTextColor,
        lightColor,
        companyLargeLogImageUrl: largeLightLogo,
        companySmallLogImageUrl: smallLogo,
        primaryColor,
        secondaryColor,
        darkColor,
        optionBgColor: lightColor,
        gray,
        black,
        white,
      })
    }
  }

  const bindAttibutes = (data) => {
    const tempFormat = _.reduce(
      data,
      (acc, val, key) => {
        let keyArr = key.split("___")
        const flag = Array.isArray(val) ? val[0] : val
        let path = _.join(keyArr, ".")
        // "Y" becomes true (granted). "N" becomes false (locked, not granted).
        // "D" stays "D": not granted for menus/routes, and locked in the role editor.
        _.set(acc, path, flag === "D" ? "D" : flag === "Y")
        return acc
      },
      {}
    )
    dispatch(userKeycloakAttributes(tempFormat))
  }

  /**
   * @Common_API_End
   */

  const onTriggerUserServiceLoggedAPI = () => {
    async function fetchLoggedIn() {
      if (UserService.isLoggedIn()) {
        let mydata = UserService.getToken((res) => {
          return res
        })
        let decoded = jwt_decode(mydata)

        setLoader(true)
        localStorage.setItem("token", mydata)
        localStorage.setItem("is_oidc", decoded?.oidc || false)
        localStorage.setItem("userName", decoded.name)
        localStorage.setItem("userEmail", decoded.preferred_username)
        localStorage.setItem("firstName", decoded.given_name)
        localStorage.setItem("lastName", decoded.family_name)
        localStorage.setItem("userId", decoded?.sub)
        if (decoded.Tenant?.length) {
          localStorage.setItem(
            "tenantName",
            decoded?.Tenant[0]?.replace("/", "")
          )
        }

        let roleArray = decoded.userRole
        const myfile = _.map(roleArray, (x, i) => {
          if (
            x !== undefined &&
            x.split("-")?.[0] === "default" &&
            x.split("-")?.[1] === "roles"
          ) {
            roleArray.splice(i, 1)
          }
        })
        var loginRole = ""
        loginRole = _.find(roleArray, function (o) {
          return o !== "offline_access"
        })

        const isSaaS = _.includes(loginRole, "SaaS-Site-Admin")
        const isSubSaaS = _.includes(loginRole, "Sub-SaaS-Admin")

        if (isSaaS) {
          if (Utils?.JSUtils?.getFlagSelectedCountryChoose()) {
            localStorage.setItem("country_code", decoded?.country || "US")
          }
        } else {
          localStorage.setItem("country_code", decoded?.country || "US")
        }

        localStorage.setItem("sourceRole", loginRole)
        let roleType = ""

        if (loginRole === "SaaS-Site-Admin") {
          roleType = "master"
        } else if (loginRole === "Sub-SaaS-Admin") {
          roleType = "portal"
        } else if (_.includes(loginRole, "SaaS-Site-Admin")) {
          roleType = "support"
        } else if (_.includes(loginRole, "Sub-SaaS-Admin")) {
          roleType = "portal_support"
        } else {
          roleType = decoded?.Tenant[0]?.toLowerCase().replace("/", "")
        }
        objUserProfileDetails = {
          userName: decoded.name,
          userEmail: decoded.preferred_username,
          firstName: decoded.given_name,
          lastName: decoded.family_name,
          userId: decoded?.sub,
          roleType: roleType.replaceAll(" ", "_"),
        }

        let is_oidc =
          localStorage.getItem("is_oidc") === "" ||
          localStorage.getItem("is_oidc") === null
            ? false
            : localStorage.getItem("is_oidc") === "true"
            ? true
            : false

        let userDetailBody = {
          tenantName:
            decoded?.Tenant?.length > 0
              ? decoded?.Tenant[0].replace("/", "")
              : "",
          realmId: localStorage.getItem("X-KC-Realm-ID"),
          keycloackRoleName: loginRole,
          keycloakUserId: is_oidc ? "" : decoded?.sub,
        }

        let headerKit = is_oidc
          ? {
              headers: {
                is_oidc: is_oidc,
              },
            }
          : {}

        let res = await ServiceAPI.fetchCommonRoleData(
          API_END_POINTS.getUserDetail,
          userDetailBody,
          headerKit
        )

        // SaaS     - Navbar Tenant Region dropdown (country_code already set)
        // SubSaaS  - res?.data?.data?.realm?.address?.country_code
        // TENANT   - res?.data?.data?.tenant?.address?.country_code

        /**
         * @TODO_STORE_TYPE
         */
        if (decoded.userRole?.length > 0 && res?.data?.data) {
          try {
            if (isSubSaaS) {
              const realmCountryCode =
                res?.data?.data?.realm?.address?.country_code || ""
              const realmCountry =
                res?.data?.data?.realm?.address?.country || ""
              if (realmCountryCode) {
                localStorage.setItem("country_code", realmCountryCode)
              }
              if (realmCountry) {
                localStorage.setItem("country_selected", realmCountry)
              }
            } else if (!isSaaS) {
              const tenantCountryCode =
                res?.data?.data?.tenant?.address?.country_code || ""
              const tenantCountry =
                res?.data?.data?.tenant?.address?.country || ""
              if (tenantCountryCode) {
                localStorage.setItem("country_code", tenantCountryCode)
              }
              if (tenantCountry) {
                localStorage.setItem("country_selected", tenantCountry)
              }
            }
          } catch (_countryResolveError) {
            // Keep JWT/navbar country_code if address payload is incomplete.
          }

          let dataKit = [{ id: "STR_TY_001", name: "DIGITMART" }]

          const adopterFunction = (dataState, page, limit) => {
            let sort = dataState.sort.reduce((acc, o) => {
              acc[o.field] = o.dir === "asc" ? 1 : -1
              return acc
            }, {})
            return {
              page,
              limit,
              filter: dataState?.filter?.filters,
              sort,
            }
          }

          const body = adopterFunction(
            {
              filter: {
                logic: "and",
                filters: [],
              },
              sort: [],
              take: 50,
              skip: 0,
            },
            1,
            50
          )
          let responseStoreType = await ServiceAPI.fetchCommonData(
            API_END_POINTS.getAllStoreTypes,
            body
          )

          if (!_.isEmpty(responseStoreType?.data?.data?.docs)) {
            dataKit = responseStoreType?.data?.data?.docs?.map((itm) => {
              if (itm?.is_active) {
                return { id: itm?.store_type_id, name: itm?.store_type }
              }
              return null
            })
            dataKit = _.compact(dataKit)
          }
          // if (!_.isEmpty(res?.data?.data?.realm?.storeTypes)) {
          //   dataKit = res?.data?.data?.realm?.storeTypes
          // }
          // if (!_.isEmpty(res?.data?.data?.tenant?.storeTypes)) {
          //   dataKit = res?.data?.data?.tenant?.storeTypes
          // }

          const { location = {} } = window || {}

          if (
            location.origin.includes("local") ||
            location.origin.includes("dev")
          ) {
            // dataKit = [...dataKit, { id: "STR_TY_002", name: "DIGITMART X" }]
          }

          console.log(
            "dataKit>> setStoreType>",
            dataKit,
            res?.data?.data?.tenant?.storeTypes
          )
          setStoreType(dataKit)
          let tabStoretypes = res?.data?.data?.tenant?.storeTypes
            .filter((val) => val.id)
            .sort((a, b) =>
              a.id.split("_")[2].localeCompare(b.id.split("_")[2])
            )
          setStoreSelectedType(tabStoretypes || [])

          // setStoreSelectedType(res?.data?.data?.tenant?.storeTypes || [])
          if (res?.data?.data?.tenant) {
            let findStoreTypes = res?.data?.data?.tenant?.storeTypes || []
            const { location = {} } = window || {}
            if (findStoreTypes.length === 1) {
              if (
                location?.origin.includes("local") ||
                location?.origin.includes("digitmart")
              ) {
                const [_findStoreTypes = {}] = findStoreTypes || []
                const { name = "" } = _findStoreTypes
                localStorage.setItem("viewStoreType", name)
              }
            } else {
              if (
                location?.origin.includes("local") ||
                location?.origin.includes("digitmart")
              ) {
                localStorage.setItem("viewStoreType", "DIGITMART")
              } else {
                localStorage.setItem("viewStoreType", "")
              }
            }
            setStoreTenantBasedType(findStoreTypes)
            let findShekel = _.filter(
              res?.data?.data?.tenant?.shelfTypes,
              function (o) {
                return o?.name === window?.getShelfTypes?.SHEKEL_TYPE_NAME
              }
            )
            localStorage.setItem(
              "isShekelSync",
              findShekel?.length > 0 ? true : false
            )
            localStorage.setItem(
              "cost_price_flag",
              res?.data?.data?.tenant?.profit_exists || false
            )
            localStorage.setItem(
              "purchase_exists_flag",
              res?.data?.data?.tenant?.purchase_exists || false
            )
            localStorage.setItem("tenantId", res?.data?.data?.tenant?.tenantId)
            localStorage.setItem(
              "tenantPaymentConfigEnable",
              res?.data?.data?.tenant?.paymentConfigEnable || false
            )
          }
          localStorage.setItem(
            "taxProvider",
            res?.data?.data?.tenant?.taxProvider?.name
          )
          localStorage.setItem("role", res?.data?.data?.role?.roleName)
          localStorage.setItem(
            "loggedInRoleIsDefault",
            String(Boolean(res?.data?.data?.role?.isDefault))
          )
          const tenantAdminEmail =
            _.get(res, "data.data.tenant.admin.email") ||
            _.get(res, "data.data.tenant.adminEmail") ||
            _.get(res, "data.data.tenant.primaryAdminEmail") ||
            ""
          if (tenantAdminEmail) {
            localStorage.setItem("tenantAdminEmail", tenantAdminEmail)
          }
          localStorage.setItem(
            "tenantAddress",
            JSON.stringify(res?.data?.data?.tenant?.address || {})
          )
          localStorage.setItem(
            "userDetailRealm",
            JSON.stringify(
              {
                ...res?.data?.data?.realm?.platformAccount,
                ...res?.data?.data?.realm?.address,
              } || {
                accountType: "",
                accountName: "",
                isDefault: false,
              }
            )
          )
          localStorage.setItem(
            "platFormAccountFlag",
            res?.data?.data?.tenant?.platformAccount?.isDefault || false
          )
          let lcCurrency = JSON.stringify(
            res?.data?.data?.tenant?.currency || {
              currency_code: "USD",
              currency_name: "American Dollar",
              currency_symbol: "$",
            }
          )

          lcCurrency = lcCurrency
            ? Utils?.JSUtils?.getCurrencyValueSpace(lcCurrency)
            : lcCurrency
          localStorage.setItem("currencyType", lcCurrency)
          bindUserLogoDetails(res?.data?.data?.theme, res?.data?.data?.realm)
          dispatch(userProfileDetails(objUserProfileDetails))
          let HITL_MODE_SAAS_FORCE =
            res?.data?.data?.role?.attributes["HITL_MODE_SAAS_FORCE"] ===
            undefined
              ? "OFF"
              : res?.data?.data?.role?.attributes["HITL_MODE_SAAS_FORCE"][0] ||
                "OFF"

          localStorage.setItem(
            "Enable_Module_Inventory_Cycle_Counts",
            res?.data?.data?.role?.attributes[
              "Enable_Module_Inventory_Cycle_Counts"
            ] === undefined ||
              res?.data?.data?.role?.attributes[
                "Enable_Module_Inventory_Cycle_Counts"
              ] === ""
              ? "OFF"
              : "ON"
          )

          if (
            res?.data?.data?.role?.roleName === "SaaS-Site-Admin" ||
            loginRole.includes("SaaS-Site-Admin") ||
            localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
          ) {
            HITL_MODE_SAAS_FORCE = "ON"
          }

          window["HITL_MODE_SAAS_FORCE"] =
            HITL_MODE_SAAS_FORCE === "ON" ? true : false
          //setHITLAccessibility

          const getLocalRoleBasedAttributes = () => {
            // loginRole

            let isLocal = false
            if (isLocal) {
              const config = require(`../ROLES/${loginRole}.json`)
              let lcBindAttributes = config
              setRoleGlobalAttributes(lcBindAttributes)
              bindAttibutes(lcBindAttributes)
              setLoader(false)
            } else {
              let lcBindAttributes = res?.data?.data?.role?.attributes
              setRoleGlobalAttributes(lcBindAttributes)
              bindAttibutes(lcBindAttributes)
              setLoader(false)
            }
          }
          if (
            `${localStorage.getItem("sourceRole") || ""}`.includes("SaaS")
          ) {
            snapshotLoginOnboardingFlags()
            await syncSaasSelectedTenantOnboardingFlags({ force: true })
          }
          getLocalRoleBasedAttributes()
        } else {
          UserService.doLogout()
          localStorage.clear()
        }
      } else {
        const { location = {} } = window || {}
        if (!location.href.includes("/auth") || !location.href.includes("/")) {
          if (location.href.includes("/receipts")) {
          } else {
            UserService.doLogin()
          }
        }
      }
    }
    fetchLoggedIn()
  }

  const checkAndGetStorageId = () => {
    let storageDetails = localStorage.getItem("storageDetails")
    if (storageDetails) {
      setStorageData(JSON.parse(storageDetails))
    }
  }

  const onInitLoad = () => {
    console.log("Build TEST!!!")
    localStorage.setItem("expandDetails", null)
    window["IS_PLANOGRAM_ENABLE_AUTO_UPDATE"] = true
    window["getShelfTypes"] = Utils?.shelfTypeConfig
    window["getGondolaTypes"] = Utils?.gondolaTypeConfig
    window["globalTranslation"] = t
    window["globalTranslationI18n"] = i18n
    window?.addEventListener("click", () => {
      const { location = {} } = window || {}
      if (
        !location.href.includes("/auth") ||
        !location.href.includes("/receipts")
      ) {
        if (localStorage.getItem("sourceRole") === null) {
          UserService.doLogout()
        }
      }
    })
    window?.addEventListener("error", (e) => {
      // if (e?.message?.includes("Uncaught")) {
      //   if (window.location.origin.includes("local")) {
      //     window.location.href = window.location.origin
      //   } else {
      //     window.location.href = window.location.origin
      //   }
      // }
    })
    checkAndGetStorageId()
  }

  const getCountryList = async () => {
    if (UserService.isLoggedIn()) {
      let defaultCountryList = await Utils?.JSUtils?.getCountryList()

      setGlobalCountryList(defaultCountryList)
      setCountryList(defaultCountryList)
    }
  }

  React.useEffect(onInitLoad, [])
  React.useEffect(onTriggerUserServiceLoggedAPI, [UserService.isLoggedIn()])
  React.useEffect(getCountryList, [])

  React.useEffect(() => {
    localStorage.setItem("storageDetails", JSON.stringify(getStorageData))
  }, [getStorageData])

  const renderHelmet = () => {
    return (
      <Helmet
        titleTemplate={`%s | ${window["brandName"]}`}
        defaultTitle={`${window["brandName"]}`}
      />
    )
  }

  const renderAppLogout = () => {
    return (
      <AppLogout
        onActive={() => {
          setIsActive(true)
        }}
        onIdle={() => {
          setIsActive(false)
        }}
      />
    )
  }

  const renderRouteItemForgotPwd = () => {
    return (
      <Route
        path={`/auth/forgetpassword`}
        exact={true}
        render={() => <ForgetPassword history={history} />}
      />
    )
  }
  const renderRouteItemReceipts = () => {
    return (
      <Route
        path={`/receipts`}
        exact={true}
        render={() => <Receipt history={history} />}
      />
    )
  }

  const renderGlobalRoutes = () => {
    return (
      <DashboardContext.Provider
        value={{
          showMore,
          setShowMore,
          routesWithActiveStatus,
          setRoutesWithActiveStatus,
          countryList,
          setCountryList,
        }}
      >
        <QueryParamProvider ReactRouterRoute={Route}>
          {isLoader ? <Spinner /> : <Routes />}
        </QueryParamProvider>
      </DashboardContext.Provider>
    )
  }

  const renderAppKit = () => {
    return (
      <AppContext.Provider
        value={{
          getAppThemes,
          setAppThemes,
          getStorageData,
          setStorageData,
          getStoreType,
          setStoreType,
          setStoreSelectedType,
          getStoreSelectedType,
          getGlobalCountryList,
          setStoreTenantBasedType,
          getStoreTenantBasedType,
          getRoleGlobalAttributes,
        }}
      >
        <StylesProvider jss={jss}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <MuiThemeProvider theme={createTheme(theme.currentTheme)}>
              <ThemeProvider theme={createTheme(theme.currentTheme)}>
                <ToastContainer />
                <Utils.GlobalAppContext.Provider
                  value={{ ...getGlobalAppStates }}
                >
                  <Router history={history}>
                    {renderRouteItemReceipts()}
                    {renderCustomRedirect(history)}
                    {renderRouteItemForgotPwd()}
                    {renderGlobalRoutes()}
                  </Router>
                </Utils.GlobalAppContext.Provider>
              </ThemeProvider>
            </MuiThemeProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </AppContext.Provider>
    )
  }
  return (
    <PageMainWrapper>
      {renderDynamicStylesColor({ getAppThemes })}
      {renderHelmet()}
      {renderAppLogout()}
      {renderAppKit()}
    </PageMainWrapper>
  )
}
export default App
